import React from "react";
import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import addToMailchimp from 'gatsby-plugin-mailchimp';

const BlogSubscribe = () => {

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async () => {
        const data = await addToMailchimp(email)

        if (data.result === "error") {
            setError(data.msg);
        } else {
            setSuccess(data.msg);
            setSubmitted(true);
        }

    }

    return (
        <>
            <div className="card blog-subscribe-section bg-light mt-5">
                {submitted ? (
                    <div className="success-msg text-center card-body p-4 p-md-5">
                        <h3 className="text-primary">{success}</h3>
                    </div>
                ) : (
                    <div className="subscribe-msg card-body p-4 p-md-5">
                        <h2 className="h3 mb-3">Subscribe</h2>
                        <p className="mb-4"><strong className="fw-bold">Join fellow entrepreneurs!</strong> Get Peerbits' latest articles straight to your inbox.</p>
                        <Form className="contact-us-form" name="Gatsby Subscribe Form">
                            <Form.Group className="mb-4">
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email address"
                                    required
                                    size="lg"
                                />
                                <p className="form-text text-danger mt-2 mb-0 text-start">
                                    {error}
                                </p>
                            </Form.Group>
                            <div className="form-action text-end">
                                <Button type="button" onClick={() => handleSubmit()} variant="" size="lg" className="btn-primary-theme">
                                    <span>Subscribe</span>
                                </Button>
                            </div>
                        </Form>
                    </div>
                )}
            </div>
        </>
    )

}

export default BlogSubscribe;
